import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useLayoutEffect,
    useRef,
    useState,
} from 'react';

import Tooltip from 'components/other/Tooltip';

import {
    formatGridColumn,
} from './functions';

import styles from './DataCell.module.scss';

const DataCell: FC<IProps> = (props) => {
    const [isOverflowed, setIsOverflowed] = useState(false);

    const contentRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const content = contentRef.current;

        if (!content) {
            return;
        }

        setIsOverflowed(content.clientWidth !== content.scrollWidth);
    }, [props.children]);

    if (!props.option.span && !props.option.width) {
        return null;
    }

    return (
        <div
            className={
                classNames(styles.dataCell, props.className, {
                    [styles.isSingleLine]: !props.option.isMultiline,
                    [styles.isMultiline]: props.option.isMultiline,
                    [styles.isBold]: props.option.isBold,
                })
            }
            style={{
                gridColumn: formatGridColumn({
                    span: props.option.span,
                    isMobile: props.isMobile,
                    maxRowWidthDesktop: props.maxRowWidthDesktop,
                    maxRowWidthMobile: props.maxRowWidthMobile,
                }),
            }}
        >
            <Tooltip
                className={styles.tooltipTrigger}
                content={props.children}
                isDisabled={!isOverflowed || props.isMobile}
                offsetTop={-11}
                offsetLeft={-11}
            >
                <div
                    ref={contentRef}
                    className={styles.content}
                >
                    {props.children}
                </div>
            </Tooltip>
        </div>
    );
};

export default DataCell;
